// extracted by mini-css-extract-plugin
export default {"not-found":"T0y6v","not-found-icon":"rZJNS","title":"Z7Pxw","message":"qAIrY","contact":"kUmEn"};